{
  "shared": {
    "backToPlatformSelection": "← Back to platform selection",
    "backToLogin": "← Back to login",
    "backToSignIn": "← Back to sign in",
    "or": "Or",
    "emailLabel": "Email Address",
    "emailPlaceholder": "name@company.com",
    "moderatorEmailPlaceholder": "moderator@company.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter your password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "signIn": "Sign In",
    "signingIn": "Signing in…",
    "signInLink": "Sign in",
    "rememberPassword": "Remember your password?",
    "legal": "By signing in, you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
    "errors": {
      "enterEmail": "Please enter your email address.",
      "enterPassword": "Please enter your password.",
      "validEmail": "Please enter a valid email address."
    },
    "twoFactor": {
      "title": "Two-Step Verification",
      "subtitleCode": "Enter the 6-digit code from your authenticator app.",
      "subtitleRecovery": "Enter one of your recovery codes.",
      "codeLabel": "Authentication code",
      "recoveryLabel": "Recovery code",
      "verify": "Verify",
      "verifying": "Verifying…",
      "useRecovery": "Use a recovery code instead",
      "useAuthenticator": "Use authenticator code instead",
      "errors": {
        "enterCode": "Enter the 6-digit code.",
        "enterRecovery": "Enter a recovery code.",
        "sessionExpired": "Session expired — sign in again.",
        "invalidCode": "Invalid code. Try again."
      }
    }
  },
  "b2bLogin": {
    "ariaLabel": "Matchpoint Intelligence sign in",
    "title": "Welcome Back",
    "subtitle": "Sign in to your Matchpoint Intelligence account",
    "noAccount": "Don't have an account?",
    "signUp": "Sign up",
    "errors": {
      "loginFailed": "Login failed. Please try again."
    }
  },
  "moderatorLogin": {
    "ariaLabel": "Moderator platform sign in",
    "title": "Welcome, Moderator",
    "subtitle": "Sign in to your Moderator Platform account",
    "errors": {
      "signInFailed": "Sign in failed. Please try again."
    }
  },
  "register": {
    "toastSuccess": "Registration request submitted successfully",
    "errors": {
      "failed": "Registration failed. Please try again.",
      "uploadFailed": "Upload failed.",
      "enterCompanyName": "Please enter your company name.",
      "enterCompanyEmail": "Please enter your company email."
    },
    "success": {
      "ariaLabel": "Registration submitted",
      "title": "Request Submitted",
      "defaultMessage": "Your company registration request has been received. We will review your application and contact you at the email address you provided.",
      "nextSteps": "Next steps",
      "nextStepsText": "Check your inbox for confirmation. Once your account is approved, you can sign in to Matchpoint Intelligence.",
      "backToSignIn": "Back to Sign In"
    },
    "ariaLabel": "Company registration request",
    "title": "Company Registration",
    "subtitle": "Submit your details to request access to Matchpoint Intelligence",
    "companyName": "Company Name",
    "companyNamePlaceholder": "Your company name",
    "companyIndustry": "Company Industry",
    "companyIndustryPlaceholder": "e.g. Manufacturing, Technology",
    "companyEmail": "Company Email",
    "companyEmailPlaceholder": "contact@company.com",
    "companyDescription": "Company Description",
    "companyDescriptionPlaceholder": "Tell us about your company...",
    "companyAvatar": "Company Avatar",
    "uploadAvatar": "Upload company avatar",
    "avatarPreview": "Avatar preview",
    "uploaded": "Uploaded",
    "removeAvatar": "Remove avatar",
    "tradeProfile": "Trade profile",
    "tradeProfileHint": "Tells us which side of the trade corridor you are on and what you are looking for, so we can match you with the right partners.",
    "howYouFoundUs": "How you found us",
    "submit": "Submit Registration Request",
    "haveAccount": "Already have an account?"
  },
  "forgotPassword": {
    "ariaLabel": "Password reset request",
    "title": "Reset Your Password",
    "subtitle": "Enter the email address associated with your account and we'll email you a 6-digit code. The code is valid for {{minutes}} minutes.",
    "toastSent": "If an account exists for {{email}}, we've emailed it a 6-digit code.",
    "sendCode": "Send Code",
    "sendingCode": "Sending code…",
    "haveCode": "Already have a code?",
    "enterIt": "Enter it",
    "errors": {
      "failed": "Failed to send the reset code. Please try again."
    }
  },
  "moderatorForgotPassword": {
    "ariaLabel": "Moderator password reset request",
    "title": "Reset Moderator Password",
    "subtitle": "Enter the email address of your Moderator Platform account and we'll email you a 6-digit code. The code is valid for {{minutes}} minutes.",
    "toastSent": "If a moderator account exists for {{email}}, we've emailed it a 6-digit code."
  },
  "resetPassword": {
    "ariaLabel": "Reset password",
    "title": "Create New Password",
    "subtitle": "We emailed a 6-digit code to your address. Enter it below with your new password. The code is valid for {{minutes}} minutes and stops working after 5 wrong attempts.",
    "toastSuccess": "Your password has been reset. Sign in with your new password.",
    "toastResent": "If an account exists for this email, a new 6-digit code is on its way.",
    "codeLabel": "6-digit code",
    "didntGetIt": "Didn't get it?",
    "resendCode": "Resend code",
    "resendCodeCooldown": "Resend code ({{seconds}}s)",
    "newPasswordLabel": "New Password",
    "newPasswordPlaceholder": "Enter new password (min. 8 characters)",
    "confirmPasswordLabel": "Confirm Password",
    "confirmPasswordPlaceholder": "Confirm your new password",
    "showConfirmPassword": "Show confirm password",
    "hideConfirmPassword": "Hide confirm password",
    "submit": "Reset Password",
    "submitting": "Resetting password…",
    "errors": {
      "failed": "Failed to reset your password. Please try again.",
      "resendFailed": "Failed to send a new code. Please try again.",
      "enterCode": "Enter the 6-digit code from the email.",
      "enterNewPassword": "Please enter a new password.",
      "passwordTooShort": "Password must be at least 8 characters long.",
      "confirmPassword": "Please confirm your password.",
      "passwordsMismatch": "Passwords do not match."
    }
  },
  "moderatorResetPassword": {
    "ariaLabel": "Moderator reset password",
    "title": "Create New Moderator Password",
    "subtitle": "We emailed a 6-digit code to your address. Enter it below with your new password. Resetting signs you out everywhere. The code is valid for {{minutes}} minutes and stops working after 5 wrong attempts.",
    "toastResent": "If a moderator account exists for this email, a new 6-digit code is on its way."
  }
}
